import type { Role } from '../../pages/users/types/rbac';

/** Staff and clinical roles that may submit service requests from a client chart. */
const REQUEST_SERVICE_FROM_CHART_ROLES: readonly Role[] = [
  'unify-admin',
  'practice-owner',
  'practice-admin',
  'provider',
  'supervisor',
];

/** True when the user may open "Request a Service" on a client chart. */
export function canRequestServiceFromChart(role: Role): boolean {
  return REQUEST_SERVICE_FROM_CHART_ROLES.includes(role);
}
